import { EmptyFolderRequest, EmptyFolderJsonResponse, getServiceAsync } from '../../../service';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    runOwsRequestWithMonitor,
    isConsumer,
    Feature,
    fullResponseOperationOption,
} from '../../../shared';
import { lazyOnBulkActionSubmitted } from 'owa-bulk-action-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export function emptyFolder(id: string, totalCount: number): Promise<EmptyFolderJsonResponse> {
    return getServiceAsync().then(service => {
        if (isFeatureEnabled('people-emptyFolder-bulk')) {
            lazyOnBulkActionSubmitted.importAndExecute(
                id /* folderId */,
                'EmptyFolder' /* scenario */,
                null /* customData */,
                totalCount
            );
        }

        const request: EmptyFolderRequest = service.Factory.emptyFolderRequest({
            FolderIds: [service.Factory.folderId({ Id: id })],
            DeleteType: isConsumer() ? 'SoftDelete' : 'MoveToDeletedItems', // Parity with jsMVVM code
            DeleteSubFolders: false,
            SuppressReadReceipt: true,
            AllowSearchFolder: true,
            ...(isFeatureEnabled('people-emptyFolder-bulk')
                ? {
                      BulkActionRequest: true,
                      BulkActionCustomData: JSON.stringify({
                          Scenario: 'EmptyFolder',
                      }),
                      BulkActionBatchSize: 10,
                  }
                : {}),
        });

        return runOwsRequestWithMonitor({
            scenarioName: 'EmptyFolder',
            feature: Feature.FolderManagement,
            operation: () =>
                service.Operation.emptyFolderOperation(
                    {
                        Header: getJsonRequestHeader(),
                        Body: request,
                    },
                    fullResponseOperationOption
                ),
            transformResponse: (response: EmptyFolderJsonResponse) => response,
        });
    });
}
